export default __webpack_public_path__ + "static/media/bg.4612e7ee.jpg";